<template>
    <div>
        <navbar></navbar>
        <div class="__homebg">
            <div class="container">
                <div class="row __flexsmail">
                    <div class="col-lg-7 col-md-7 col-sm-7 __mobidown">
                        <p class="__welf">Welcome to findworka</p>
                        <p class="__welf1">Hire Africa's<br> top software talents</p>
                        <p class="__welf2">Findworka is an elite network of pre-vetted African software developers who are tested, graded and effectively matched with our partners in an integrated talent and project management ecosystem</p>
                        <!-- <p class="__welf2">Findworka is a fast-growing network of Africa's finest tech talents being effectively matched with the most ambitious companies and projects in an integrated talent and project management ecosystem.</p> -->
                        <div class="__toplink">
                            <router-link class="btn __linkbtn" to="/build">Build Your Product</router-link>
                            &nbsp;&nbsp;
                            <a href="https://hire.findworka.com" target="_blank" class="btn __linkbtn1" >Hire Talents</a>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-5 __mobiup">
                        <img src="../assets/img/map.svg" class="img-responsive">
                    </div>
                </div>
            </div>
            <div class="__topcont">
                <div class="__top"></div>
                <div class="__topin"></div>
                <div class="__top1"></div>
                <div class="__topin1"></div>
                <div class="__top2"></div>
                <div class="__topin2"></div>
                <div class="__top3"></div>
                <div class="__topin3"></div>
                <!-- <div class="__top4"></div>
                <div class="__topin4"></div>
                <div class="__top5"></div>
                <div class="__topin5"></div>
                <div class="__top6"></div>
                <div class="__topin6"></div> -->
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7">
                    <p class="__hirep">Hire from our pool<br> of talents</p>
                    <p class="__hirep1">Extend your team by hiring from our pool of topnotch tech talents and experience the best delivery on your projects.</p>

                    <div id="carousel-example-generic" class="carousel slide" data-ride="carousel" data-interval="false" >
                        <ol class="carousel-indicators">
                            <!-- <li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
                            <li data-target="#carousel-example-generic" data-slide-to="1"></li>
                            <li data-target="#carousel-example-generic" data-slide-to="2"></li> -->
                        </ol>
                        <div class="carousel-inner __carousel-innert">
                            <div class="item active">
                                <div class="__caroimg"></div>
                                <!-- <img src="http://placehold.it/1200x500/3498db/2980b9" alt="First slide"> -->
                                <!-- <div class="carousel-caption">
                                    <h3>
                                        First slide</h3>
                                    <p>
                                        Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                                </div> -->
                            </div>
                            <div class="item">
                                <div class="__caroimg1"></div>
                                <!-- <div class="carousel-caption">
                                    <h3>
                                        Second slide</h3>
                                    <p>
                                        Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                                </div> -->
                            </div> 
                            <div class="item">
                                <div class="__caroimg2"></div>
                                <!-- <div class="carousel-caption">
                                    <h3>
                                        Third slide</h3>
                                    <p>
                                        Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                                </div> -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-9 col-md-9 col-sm-8 col-xs-6">
                                <a class="left carousel-control __carousel-controlt" href="#carousel-example-generic" data-slide="prev">
                                    <!-- <span class="glyphicon glyphicon-chevron-left"></span> -->
                                    <!-- <span><i class="fas fa-angle-left"></i></span> -->
                                    <span><i class="fas fa-caret-left"></i></span>
                                </a>
                                <a class="right carousel-control __carousel-controlt" href="#carousel-example-generic" data-slide="next">
                                    <!-- <span class="glyphicon glyphicon-chevron-right"></span> -->
                                    <!-- <span><i class="fas fa-angle-right"></i></span> -->
                                    <span><i class="fas fa-caret-right"></i></span>
                                </a>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                                <router-link to="/talent" class="__sthringlink">Start hiring <img src="../assets/img/right-arrow.svg"> </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5">
                    <div class="row __rowt">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <i class="__icon fas fa-cube"></i>
                            <p class="__hidep">Deep tech</p>
                            <p class="__hidep1">Machine learning<br> Artificial intelligence<br> Deep learning</p>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <i class="__icon fas fa-code"></i>
                            <p class="__hidep">Full stack development</p>
                            <p class="__hidep1">JavaScript<br>Node<br>PHP</p>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <i class="__icon fas fa-palette"></i>
                            <p class="__hidep">UX & product design</p>
                            <p class="__hidep1">UI design<br>UX research<br>Interaction</p>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <i class="__icon fas fa-mobile-alt"></i>
                            <p class="__hidep">Mobile development</p>
                            <p class="__hidep1">iOS<br>Android<br>Native</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="__midbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-8">
                        <p class="__ourp">Our Saucecode<br>programmes</p>
                        <p class="__ourp1">An active community of technology lovers. We build, collaborate and share ideas.</p>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-12">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <a href="https://hack.saucecode.xyz/" target="blank"><div class="__impcard">
                                    <div class="__impimg __acadimg"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Hackathon</p>
                                        <p class="__impp1">Challenging the talents in our ecosystem, encouraging programming best practise & promoting collaboration</p>
                                        <p class="__imppa">Visit page <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></a>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <a href="http://saucecode.xyz/hackathon/alpha" target="blank"><div class="__impcard">
                                    <div class="__impimg __sauceimg"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Campus Alpha</p>
                                        <p class="__impp1">A collection of tech leaders in various institutions, leading the pack of the next generation of developers</p>
                                        <p class="__imppa">Become an alpha <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></a>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <a href="http://saucecode.xyz/" target="blank"><div class="__impcard">
                                    <div class="__impimg __proimg"></div>
                                    <div class="__imppc">
                                        <p class="__impp">Events</p>
                                        <p class="__impp1">Our closely knit circle of techies, staying updated on tech trends and following gig alerts.</p>
                                        <p class="__imppa">See events <img src="../assets/img/right-arrow.svg"></p>
                                    </div>
                                </div></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
			<div class="row">
				<div class="col-lg-4 col-md-4 col-sm-4 p-0">
					<router-link to="/build"><div class="__ourproductimg">
						<p class="__ourproduct1">Engineering <br>Management</p>
                        <p class="__ourproduct2">Form your team <img src="../assets/img/right-arrow1.svg"> </p>
					</div></router-link>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4 p-0">
					<router-link to="/pro"><div class="__ourproductimg1">
						<p class="__ourproduct1">Become a<br>Findworka PRO</p>
                        <p class="__ourproduct2">Become our pro <img src="../assets/img/right-arrow1.svg"> </p>
					</div></router-link>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4 p-0">
					<router-link to="/talent"><div class="__ourproductimg2">
						<p class="__ourproduct1">Talent<br>Recruitment</p>
                        <p class="__ourproduct2">Hire talents <img src="../assets/img/right-arrow1.svg"> </p>
					</div></router-link>
				</div>
            </div>
		</div>

        <div class="__wedobg">
            <div class="container">
                <p class="__wedop">This is what we do</p>
                <p class="__wedop1">Findworka builds amazing software products, whether it is just an MVP or the nth version of your platform.<br> We also supply development talents for your contract and full-time position.</p>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icond fas fa-code"></i>
                        <p class="__hidep">Software Development</p>
                        <p class="__hidep1">Whatever application, or development we have the guys skilled for it</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icond fas fa-draw-polygon"></i>
                        <p class="__hidep">UX & Product Design</p>
                        <p class="__hidep1">From screen to screen, we make brilliant designs that tell compelling stories.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icond fas fa-clock"></i>
                        <p class="__hidep">Project Management</p>
                        <p class="__hidep1">Take your project from start to finish and ensure that you have a world-class product.</p>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icond fas fa-users"></i>
                        <p class="__hidep">Talent Outsourcing</p>
                        <p class="__hidep1">Our Pros are elite squad of pre-vetted technical talents.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="__countbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__contp text-center">10,000+</p>
                        <p class="__contp1 text-center">Active members on the<br> saucecode community.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__contp text-center">510+</p>
                        <p class="__contp1 text-center">Number of professionals in<br> our PRO network.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__contp text-center">120+</p>
                        <p class="__contp1 text-center">Number of hired developers<br>and designers.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="__flotbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="__bouncdiv hidden-xs">
                            <img src="../assets/img/GLORY.png" class="__bounceimg">
                            <img src="../assets/img/IRENE.png" class="__bounceimg1">
                            <img src="../assets/img/MUTIAT.png" class="__bounceimg2">
                            <img src="../assets/img/oyin.png" class="__bounceimg3">
                            <img src="../assets/img/WILFRED.png" class="__bounceimg4">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__fsignpro text-center">Sign up as our Pro</p>
                        <p class="__fsignpro1 text-center">By becoming a Findworka Pro, you get premium access to the best software design and development projects.</p>
                        <p class=" text-center"><router-link to="/pro" class="btn __fsibtn">Become our pro <img src="../assets/img/right-arrow-top1.svg"></router-link></p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="__bouncdiv hidden-xs">
                            <img src="../assets/img/ABIMBOLA.png" class="__bounceimg5">
                            <img src="../assets/img/BOYE.png" class="__bounceimg6">
                            <img src="../assets/img/TEMIDAYO.png" class="__bounceimg7">
                            <img src="../assets/img/CHUCKS.png" class="__bounceimg8">
                            <img src="../assets/img/SHOLA.png" class="__bounceimg9">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="__abbg">
            <div class="container">
                <div class="row __flexsmail">
                    <div class="col-lg-8 col-md-8 col-sm-8 __mobidown">
                        <div class="__inabbg">
                            <p class="__abp">About our team</p>
                            <p class="__abp1">Our team is made up of affable, competent people who are passionate about building software products and helping ambitious people and companies succeed. We are smart, talented, and sure do know how to have fun!</p>
                            <p class="__ablink"><router-link to="/about">Our company <img src="../assets/img/right-arrow1.svg"> </router-link></p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 __mobiup">
                        <img src="../assets/img/about.png" class="__ouabimg">
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <p class="__hirep">Clients & Friends</p>
            <p class="__hirep1">Meet some of our friends and partners from around the world</p>
            <div class="__logflx">
                <img src="../assets/img/tracka.png" class="__clifriimg __neclif">
                <img src="../assets/img/logoeko.png" class="__clifriimg">
                <img src="../assets/img/Afrolynk.png" class="__clifriimg">
                <img src="../assets/img/BudgIT.png" class="__clifriimg">
                <img src="../assets/img/civic.png" class="__clifriimg">
                <img src="../assets/img/Layer5.png" class="__clifriimg __neclif">
                <img src="../assets/img/CCHUB.png" class="__clifriimg">
                <img src="../assets/img/eko360.png" class="__clifriimg __neclif">
                <img src="../assets/img/followm.png" class="__clifriimg">
                <img src="../assets/img/riby.png" class="__clifriimg __neclif">
                <img src="../assets/img/lifebank.png" class="__clifriimg">
            </div>
            

            <div class="row">
                <div v-for="(project,i) in projects.slice(0,4)" :key="`${i}`">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <button class="__findbtn" @click="findProject(project.slug)">
                            <div class="__meetd">
                                <figure class="effect">
                                    <img :src="project.bannerImage" class="__climg">
                                    <figcaption class="__figcaption">
                                        <p class="__meetdname">{{ project.name }}</p>
                                        <p class="__dept">{{ project.tasks }}</p>
                                        <p class="__soci">{{ project.shortDescription }}</p>
                                        <p class="__a">Learn More &nbsp;<img src="../assets/img/right-arrow1.svg"></p>
                                    </figcaption>
                                </figure>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            <br>

            <router-link to="/project" class="__prolink">All our projects <img src="../assets/img/right-arrow-black.svg"></router-link>
        </div>

        <div class="__budbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-8">
                        <p class="__wedop">Building the next generation<br> of tech talents</p>
                        
                    </div>
                </div>
                
                
                <div class="row">
                    <div class="col-xl-5 col-lg-5 col-md-5">
                        <p class="__wedop1">Findworka academy is a fellowship program for aspiring developers to receive training from first-rate developers.</p>
                        <router-link to="/academy" class="btn __joinlink">Join our academy</router-link>
                    </div>
                    <div class="col-xl-7 col-lg-7 col-md-7">
                        <div class="__fdacad">
                            <div class="__updiv">
                                <img src="../assets/img/build.png" class="__updowimg">
                            </div>
                            <div class="__downdiv">
                                <img src="../assets/img/build1.png" class="__updowimg">
                            </div>
                            <div class="__updiv">
                                <img src="../assets/img/build2.png" class="__updowimg">
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                <div class="__updiv">
                                    <img src="../assets/img/build.png" class="__updowimg">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                <div class="__downdiv">
                                    <img src="../assets/img/build1.png" class="__updowimg">
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                <div class="__updiv">
                                    <img src="../assets/img/build2.png" class="__updowimg">
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="__prodbg">
            <div class="container">
                <p class="__ourpro">Our products</p>
                <p class="__ourpro1">We are empowering today’s companies with the technologies needed to succeed in the evolving digital economy. Check out our latest products</p>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="__prodcard">
                            <p class="__prodp">Kostoma</p>
                            <p class="__prodp1">A productivity tool to make your<br> people and business succeed faster.</p>
                            <p class="__prodplink"><a href="" target="blank">View platform <img src="../assets/img/right-arrow-black.svg"></a></p>
                            <img src="../assets/img/kostoma.png" class="img-responsive">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="__prodcard1">
                            <p class="__prodp">Horus</p>
                            <p class="__prodp1">Horus has a team builder, talent on-boarding and shortlist, and project management assistant that helps to guarantee fulfillment for all your technical projects.</p>
                            <p class="__prodplink"><a href="https://horus.findworka.com/" target="blank">View platform <img src="../assets/img/right-arrow-black.svg"></a></p>
                            <img src="../assets/img/Dashboard.png" class="img-responsive">
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="container">
            <p class="__testip">Testimonials</p><br>
            <!-- <p class="__testip1">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor  incididunt ut labore et<br> dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex</p><br> -->

            <carousel class="__slidtop" :autoplay="true" :nav="true" :items="3" :autoplayHoverPause="true" :dots="false" :margin="15" :loop="true" :autoplayTimeout="2000" :responsive="{0:{items:1,nav:false},600:{items:2,nav:false},1024:{items:3,nav:true}}">
                <div class="__tescard">
                    <p class="__tesp">Findworka Pros are very competent, committed and have worked on some of our projects. You don’t meet devs like them everyday. They make tech outsourcing look super.</p>
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <img src="../assets/img/Bosun_findworka.jpg" class="__tesimg">
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                            <p class="__tesp1">Bosun Tijani</p>
                            <p class="__tesp2">Co-founder, Co-creation Hub Nigeria</p>
                        </div>
                    </div>
                </div>
                <div class="__tescard1">
                    <p class="__tesp">I have used Findworka and I can boldly vouch for their freelancers. It is easy to connect with them and they deliver on time.</p>
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <img src="../assets/img/seun_findworka.jpg" class="__tesimg">
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                            <p class="__tesp1">Oluseun Onigbinde</p>
                            <p class="__tesp2">Co-founder, Budgit</p>
                        </div>
                    </div>
                </div>
                <div class="__tescard2">
                    <p class="__tesp">My first major gig on Findworka brought in N200,000 in one week. The platform is absolutely amazing for those looking to earn more at their own convenience.</p>
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                            <img src="../assets/img/Andyson_findworka.png" class="__tesimg">
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                            <p class="__tesp1">Andyson Utomudo</p>
                            <p class="__tesp2">Senior backend developer, Findworka Pro</p>
                        </div>
                    </div>
                </div>
            </carousel>
            <!-- <div class="row">
				<div class="col-lg-4 col-md-4 col-sm-4">
					<div class="__tescard">
						<p class="__tesp">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p>
						<div class="row">
							<div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
								<img src="../assets/img/hackathon.png" class="__tesimg">
							</div>
							<div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
								<p class="__tesp1">First name, last name</p>
								<p class="__tesp2">Position, Company</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<div class="__tescard1">
						<p class="__tesp">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p>
						<div class="row">
							<div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
								<img src="../assets/img/hackathon.png" class="__tesimg">
							</div>
							<div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
								<p class="__tesp1">First name, last name</p>
								<p class="__tesp2">Position, Company</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<div class="__tescard2">
						<p class="__tesp">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor  incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p>
						<div class="row">
							<div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
								<img src="../assets/img/hackathon.png" class="__tesimg">
							</div>
							<div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
								<p class="__tesp1">First name, last name</p>
								<p class="__tesp2">Position, Company</p>
							</div>
						</div>
					</div>
				</div>
			</div> -->
        </div>

        <div class="__hirbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-6">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                                <i class="__icond1 fas fa-laptop"></i>
                                <!-- <img src="../assets/img/hackathon.png" class="__tesimg"> -->
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                <p class="__hirp">Build your product</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2"></div>
                            <div class="col-lg-10 col-md-10 col-sm-10">
                                <p class="__hirp1">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                                <router-link to="/build" class="btn __startbtn">Start now</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <div class="__midline hidden-xs"></div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-6">
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-3">
                                <i class="__icond1 fas fa-code"></i>
                                <!-- <img src="../assets/img/hackathon.png" class="__tesimg"> -->
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-9">
                                <p class="__hirp">Hire a developer</p>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-lg-2 col-md-2 col-sm-2"></div>
                            <div class="col-lg-10 col-md-10 col-sm-10">
                                <p class="__hirp1">Hire from our network of pre-vetted and handpicked programming talents for your full-time and contract engagements.</p>
                                <a href="https://hire.findworka.com" target="_blank" class="btn __startbtn">Hire a dev</a>
                                <!-- <router-link to="/talent" class="btn __startbtn">Hire a dev</router-link> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';
import carousel from 'vue-owl-carousel';
import loadProjects from '../assets/js/projects.json'

export default {
    components: { carousel,
    navbar,
    },

    name:'projects',
    data(){
        return {
            projects: ''
        }
    },
    mounted() {
        this.projects = loadProjects
        this.selectedProject = this.$store.state.found
        console.log(selectedProject)

    },
    methods: {
        findProject(slug){
				let array = this.projects
				for (let i=0; i < array.length; i++) {
					if (array[i].slug === slug) {
						this.$store.state.found = i
						console.log(this.$store.state.found)
					}
				this.$router.push('/portfolio')
				}
			}
    }
}
</script>

<style scoped>
@import '../assets/css/home';

</style>


// WEBPACK FOOTER //
// src/components/home.vue